import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

function Search(props) {
  const { width, height, fill, className } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 174 175"
      className={classNames({ [className]: !!className })}
    >
      <title>Search</title>
      <path
        fill={fill}
        d="M98.031 97.887c-17.812 17.812-46.793 17.812-64.605 0-17.812-17.812-17.812-46.793 0-64.605 17.812-17.812 46.793-17.812 64.605 0 17.812 17.812 17.812 46.793 0 64.605m14.053-78.658C85.35-7.505 41.162-6.379 15.96 22.707c-20.83 24.043-21.335 60.06-1.137 84.637 22.738 27.67 62.58 31.106 89.562 11.398l55.28 55.278a2 2 0 0 0 2.827 0l11.314-11.314a2 2 0 0 0 0-2.828L118.528 104.6c19.211-26.043 16.761-62.165-6.444-85.37"
        fillRule="evenodd"
      />
    </svg>
  )
}

Search.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
}

export default Search
